<template>
  <b-modal
    id="'justificativa'"
    :ref="'justificativa'"
    hide-footer
    hide-header
    centered
    size="md"
    no-close-on-backdrop
  >
    <b-row>
      <b-col>
        <b-row>
          <b-col cols="12">
            <b-button
              variant="none"
              class="close "
              @click="cancelar()"
            >
              <span aria-hidden="true">&times;</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            style="text-align:center;"
          >
            <h4>
              Informe o motivo de ter recusado o documento!
            </h4>
          </b-col>
          <div
            class="mt-1 px-1"
            style="flex-grow:1"
          >
            <b-row>
              <b-col cols="12">
                <b-textarea
                  v-model="just"
                  placeholder="Justifique"
                  rows="5"
                  max-rows="6"
                />
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col cols="6">
                <b-btn
                  variant="danger"
                  class="w-100"
                  @click="cancelar()"
                >Cancelar</b-btn>
              </b-col>
              <b-col cols="6">
                <b-btn
                  variant="success"
                  class="w-100"
                  @click="recusar()"
                >Recusar</b-btn>
              </b-col>
            </b-row>
          </div>
        </b-row>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'Justificativa',
  props: {
    value: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      just: '',
    }
  },
  created() {
    this.$nextTick(() => {
      this.$refs.justificativa.show()
    })
  },
  methods: {
    cancelar() {
      this.$refs.justificativa.hide()
      this.$emit('cancelar')
    },
    recusar() {
      if (!this.just) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'A justificativa da homologação recusada é obrigatório.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      } else {
        this.$refs.justificativa.hide()
        this.$emit('hidden', this.just)
      }
    },
  },
}
</script>
